import { supabase } from "../supabase/SupabaseClient";

/* Las encomiendas, vistas desde la oficina.
 *
 * ── POR QUÉ ESTO NO ESTÁ EN LA PWA ─────────────────────────────────────────
 *
 * El mostrador de Río Grande y el chofer usan `encomiendas.fibot.ar`, que es
 * una PWA aparte y offline-first porque allá el internet se corta. Esta
 * pantalla es la otra mitad: la de la gente sentada con señal que necesita
 * mirar TODO junto y contestar «¿dónde está el paquete de Pepito?». Son dos
 * problemas distintos y por eso son dos apps distintas, con la misma base.
 *
 * Acá NO se carga nada. Una guía se da de alta donde se pesa el bulto.
 *
 * ── LO QUE DE VERDAD RESTRINGE ES LA RLS ───────────────────────────────────
 *
 * Las tablas `enc_*` piden `ver.encomiendas` para leer, del lado de la BASE.
 * Sin ese permiso estas consultas vuelven vacías aunque se las llame desde la
 * consola del navegador. El menú sólo decide qué baldosa se dibuja.
 *
 * Son los MISMOS permisos que usa la PWA, a propósito: quien atiende
 * encomiendas es la misma persona de los dos lados, y un segundo permiso para
 * lo mismo sería una lista más para mantener y un día olvidar.
 */

/* Las guías y sus bultos, en dos consultas.
 *
 * Dos y no una con join anidado: el `select` con relación embebida de
 * PostgREST arrastra la relación completa por fila y acá la tabla de bultos se
 * usa entera para derivar el estado. Con ~10 guías por día esto son dos
 * lecturas chicas; si algún día son miles, el que optimice va a encontrar acá
 * el motivo por el que hoy no hace falta.
 *
 * El límite es de GUÍAS, no de bultos: cortar bultos dejaría guías con la
 * mitad de sus bultos y el estado derivado saldría mal —una guía terminada se
 * vería «parcial»—, que es exactamente la mentira que esta pantalla existe
 * para no decir.
 */
export async function cargas(limite = 200) {
  const { data: guias, error } = await supabase
    .from("enc_guias")
    .select(
      "id, tipo, origen, destino, remitente, destinatario, destinatario_telefono, bultos_total, nota, creado_en, anulado_en, aviso_llegada_en",
    )
    .order("creado_en", { ascending: false })
    .limit(limite);
  if (error) throw error;

  const ids = (guias || []).map((g) => g.id);
  if (!ids.length) return { guias: [], bultosPorGuia: {} };

  const { data: bultos, error: e2 } = await supabase
    .from("enc_bultos")
    .select("id, guia_id, nro, estado")
    .in("guia_id", ids);
  if (e2) throw e2;

  const bultosPorGuia = {};
  (bultos || []).forEach((b) => {
    (bultosPorGuia[b.guia_id] = bultosPorGuia[b.guia_id] || []).push(b);
  });
  return { guias: guias || [], bultosPorGuia };
}

/* El recorrido de una guía: el event-log crudo, que es la verdad.
 *
 * Se pide al abrir una guía y no antes: son la mayoría de las filas del sector
 * y casi nunca se miran. La hora que vale es `escaneado_en` —cuándo pasó— y no
 * `creado_en` —cuándo la cola consiguió señal para contarlo—; con señal mala
 * pueden ser horas distintas, y la que le importa a quien pregunta es la
 * primera. Se ordena por eso mismo.
 */
export async function recorrido(guiaId) {
  const { data, error } = await supabase
    .from("enc_eventos")
    .select(
      "id, bulto_id, tipo, interno, lugar, detalle, usuario_nombre, escaneado_en, creado_en",
    )
    .eq("guia_id", guiaId)
    .order("escaneado_en", { ascending: false });
  if (error) throw error;
  return data || [];
}
